import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=02cf97aa&scoped=true&"
import script from "./Blogs.vue?vue&type=script&setup=true&lang=js&"
export * from "./Blogs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Blogs.vue?vue&type=style&index=0&id=02cf97aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf97aa",
  null
  
)

export default component.exports